export const $data = {
    weChatId: 34443,//正式服务号戴尔易安信市场活动
    tenantId: 453,
    schemaId: 498,
    customFormId: 2504143021982020,
    linkId: 47515,
    openId: "",
    instanceId: 0,
    defaultMeetingBg: "../public/img/defaultbanner/listbanner.jpg",  //默认会议背景图片
    bannerList: {
        index: 2504093249381335, //首页banner
        solution: 2504161481272471, //广告位banner
        networking: 2504172752195986, //Networking
        monitors: 2504161352398500,
        'hyperconverged-infrastructure': 2504161584892288,
        workstations: 2504162531346777,
        laptops: 2504162598532112,
        'data-storage': 2504162782039762,
        servers: 2504164029685857,
        desktops: 2504164096002313,
        'data-protection': 2504164110431175
    },
    activity: {
        replayWebinarCatId: 151843,
        replayEventCatId: 2403011065085914
    },
    //发送文件配置
    email: {
        emailSubject: '戴尔易安信(Dell EMC)企采中心-相关资料下载',
        senderEmail: 'dellEmc@dell.com',
        senderName: '戴尔易安信(Dell EMC)企采中心'
    },
    tab:{
        "networking": "Networking",
        "monitors": "Monitors",
        'hyperconverged-infrastructure': "Hyperconverged Infrastructure",
        "workstations": "Workstations",
        "laptops": "Laptops",
        'data-storage': "Data Storage",
        "servers": "Servers",
        "desktops": "Desktops",
        'data-protection': "Data Protection"
    },
    tab2:{
        "Networking": "networking",
        "Monitors": "monitors",
        "Hyperconverged Infrastructure": 'hyperconverged-infrastructure',
        "Workstations": "workstations",
        "Laptops": "laptops",
        "Data Storage": 'data-storage',
        "Servers": "servers",
        "Desktops": "desktops",
        "Data Protection": 'data-protection'
    },
    menu: [
        {
            id: '1',
            title: 'Home',
            link: '/'
        },
        {
            id: '2',
            title: 'Product Center',
            children: [
                {
                    id: '201',
                    title: 'Laptops',
                    link: '/products'
                },
                {
                    id: '202',
                    title: 'Desktops',
                    link: '/products'
                },
                {
                    id: '203',
                    title: 'Workstations',
                    link: '/products'
                },
                {
                    id: '204',
                    title: 'Monitors',
                    link: '/products'
                },
                {
                    id: '205',
                    title: 'Servers',
                    link: '/products'
                },
                {
                    id: '206',
                    title: 'Data Storage',
                    link: '/products'
                },
                {
                    id: '207',
                    title: 'Data Protection',
                    link: '/products'
                },
                {
                    id: '208',
                    title: 'Hyperconverged Infrastructure',
                    link: '/products'
                },
                {
                    id: '209',
                    title: 'Networking',
                    link: '/products'
                },
            ]
        },
        {
            id: '3',
            title: 'Event Hub',
            children: [
                {
                    id: '301',
                    title: 'Webinar',
                    link: '/webinar'
                },
                {
                    id: '302',
                    title: 'Event',
                    link: '/event'
                }
            ]
        },
        {
            id: '4',
            title: 'Resource Library',
            link: '/meetings/resource'
        }
    ],
    tabList: [
        {
            id: '201',
            title: 'Laptops',
            link: '/products'
        },
        {
            id: '202',
            title: 'Desktops',
            link: '/products'
        },
        {
            id: '203',
            title: 'Workstations',
            link: '/products'
        },
        {
            id: '204',
            title: 'Monitors',
            link: '/products'
        },
        {
            id: '205',
            title: 'Servers',
            link: '/products'
        },
        {
            id: '206',
            title: 'Data Storage',
            link: '/products'
        },
        {
            id: '207',
            title: 'Data Protection',
            link: '/products'
        },
        {
            id: '208',
            title: 'Hyperconverged Infrastructure',
            link: '/products'
        }
    ],
    tabListWAP: [
        {
            id: '201',
            title: 'Laptops',
            link: '/products'
        },
        {
            id: '205',
            title: 'Servers',
            link: '/products'
        },
        {
            id: '202',
            title: 'Desktops',
            link: '/products'
        },
        {
            id: '206',
            title: 'Data Storage',
            link: '/products'
        },
        {
            id: '203',
            title: 'Workstations',
            link: '/products'
        },
        {
            id: '207',
            title: 'Data Protection',
            link: '/products'
        },
        {
            id: '204',
            title: 'Monitors',
            link: '/products'
        },
        {
            id: '208',
            title: 'Hyperconverged Infrastructure',
            link: '/products'
        },
    ]
}